/**
 * Constant in the dashboardApp. Defines colors as expected in chart.js
 * configuration.
 * For a detailed color configuration the colors could be:
 * {
 *  fillColor: 'rgba(1, 160, 176, 0.8)',
 *  strokeColor: 'rgba(1, 160, 176, 1)',
 *  highlightFill: 'rgba(1, 160, 176, 0.9)',
 *  highlightStroke: 'rgba(1, 160, 176, 1)'
 * },
 * {
 *  fillColor: 'rgba(114, 52, 173, 0.8)',
 *  strokeColor: 'rgba(114, 52, 173, 1)',
 *  highlightFill: 'rgba(114, 52, 173, 0.9)',
 *  highlightStroke: 'rgba(114, 52, 173, 1)'
 * }
 *
 */

export type ChartColors = string[];
const chartColors: ChartColors = [
  'rgba(1,160,176,0.8)',
  'rgba(114,52,173,0.8)',
];

export const ChartColorsProvider: { provide: string; useValue: ChartColors } = {
  provide: 'chartColors',
  useValue: chartColors,
};
